import { render, staticRenderFns } from "./CaseUsers.vue?vue&type=template&id=fa67f81e&scoped=true&"
import script from "./CaseUsers.vue?vue&type=script&lang=ts&"
export * from "./CaseUsers.vue?vue&type=script&lang=ts&"
import style0 from "./CaseUsers.vue?vue&type=style&index=0&id=fa67f81e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa67f81e",
  null
  
)

export default component.exports